var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import { Field } from "./Field";
import Group from "./Group";
import Stock from "../Stock/Stock";
import { ProductQuantitySelector } from "./ProductQuantitySelector";
import ProductContextVariable from "../ContextVariable/ProductContextVariable";
import ContextVariableFilter from "../../filter/ContextVariable/ContextVariableFilter";
var Product = /** @class */ (function (_super) {
    __extends(Product, _super);
    /** Constructor **/
    function Product(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.uid = null;
        _this.establishmentUid = null;
        _this.internalType = PRODUCT_INTERNAL_TYPE.ITEM;
        _this.contextVariables = [];
        _this.customerLabels = [];
        //Todo: à implémenter
        _this.variables = [];
        /** Field **/
        _this._name = {};
        _this._description = {};
        _this.fields = [];
        _this.iconUploadUid = null;
        _this.needDelivery = false;
        _this._position = 0;
        _this._groups = [];
        _this.stockUid = null;
        _this.stock = new Stock();
        _this.quantitySelector = new ProductQuantitySelector();
        /** Option **/
        _this.onSale = true;
        _this.visible = true;
        /** Price **/
        _this.ventilate = false;
        /** Price HT **/
        _this._price = 0;
        /** Price TTC **/
        _this._priceWithTax = 0;
        /** Price VAT **/
        _this._vat = 2000;
        /** Extra **/
        _this.extras = _this.get_random_value_to_extra();
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Product.buildFromJson(_this, obj);
        return _this;
    }
    Object.defineProperty(Product.prototype, "name", {
        get: function () {
            if (this._name && this._name.FR) {
                return this._name.FR;
            }
            return '';
        },
        set: function (value) {
            if (this._name === undefined) {
                this._name = {};
            }
            this._name.FR = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "alternate_name", {
        get: function () {
            return this.get_field("alternateName");
        },
        set: function (value) {
            this.set_field("alternateName", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "description", {
        get: function () {
            if (this._description && this._description.FR) {
                return this._description.FR;
            }
            return '';
        },
        set: function (value) {
            if (this._description === undefined) {
                this._description = {};
            }
            this._description.FR = value;
        },
        enumerable: false,
        configurable: true
    });
    Product.prototype.getCurrentProductContext = function (date, contextVariables) {
        // On trie les contextes par priorité.
        contextVariables = ContextVariableFilter.sortByPriority(contextVariables, false);
        // On match le contextVariabel avec le productContextVariable
        for (var _i = 0, contextVariables_1 = contextVariables; _i < contextVariables_1.length; _i++) {
            var contextVariable = contextVariables_1[_i];
            for (var _a = 0, _b = this.contextVariables; _a < _b.length; _a++) {
                var productContext = _b[_a];
                // On cherche le producContextVariable
                if (productContext.contextVariableUid === contextVariable.uid) {
                    // On regarde si le context qui match est actif.
                    if (productContext.getCurrentContext(date, [contextVariable])) {
                        return productContext;
                    }
                }
            }
        }
        // Si rien n'est trouvé alors aucun context est actif.
        return null;
    };
    Product.prototype.isContextIsInProduct = function (context) {
        for (var _i = 0, _a = this.contextVariables; _i < _a.length; _i++) {
            var c = _a[_i];
            if (c.contextVariableUid === context.uid) {
                return true;
            }
        }
        return false;
    };
    Object.defineProperty(Product.prototype, "position", {
        get: function () {
            return this._position;
        },
        set: function (value) {
            if (value >= 0)
                this._position = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "groups", {
        get: function () {
            return this._groups;
        },
        set: function (value) {
            if (value.length > 0) {
                this.isProductUniquable = true;
            }
            this._groups = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "maximumQuantity", {
        /** Quantity **/
        // public maximumQuantity: number | null = null;
        get: function () {
            return this.quantitySelector.maxQuantity;
        },
        enumerable: false,
        configurable: true
    });
    Product.prototype.isProductTotalyUniquable = function () {
        if (!this.quantitySelector.isProductUniquable) {
            return false;
        }
        for (var _i = 0, _a = this.contextVariables; _i < _a.length; _i++) {
            var context_1 = _a[_i];
            if (!context_1.quantitySelector.isProductUniquable) {
                return false;
            }
        }
        return true;
    };
    Object.defineProperty(Product.prototype, "isProductUniquable", {
        /**
         * @Description: Regarde si le produit est complètement 'uniquable'
         * @return: boolean
         * **/
        get: function () {
            return this.isProductTotalyUniquable();
        },
        set: function (value) {
            this.quantitySelector.isProductUniquable = value;
            if (value) {
                for (var _i = 0, _a = this.contextVariables; _i < _a.length; _i++) {
                    var contextVariable = _a[_i];
                    contextVariable.quantitySelector.isProductUniquable = true;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "price", {
        get: function () {
            return this._price;
        },
        set: function (value) {
            this._price = parseInt(value + "");
            this._priceWithTax = Math.round(this._price * (1 + (this._vat / (100 * 100))));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "priceWithTax", {
        get: function () {
            return this._priceWithTax;
        },
        set: function (value) {
            this._priceWithTax = Math.round(value);
            this._price = Math.round(this._priceWithTax / (1 + (this._vat / (100 * 100))));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "vat", {
        get: function () {
            return this._vat;
        },
        set: function (value) {
            this._vat = value;
            this._priceWithTax = Math.round(this._price * (1 + (this._vat / (100 * 100))));
        },
        enumerable: false,
        configurable: true
    });
    Product.prototype.get_random_value_to_extra = function () {
        var colors = [
            "red",
            "orange",
            "yellow",
            "olive",
            "green",
            "teal",
            "blue",
            "violet",
            "purple",
            "pink",
            "brown",
            "grey",
            "black"
        ];
        var random = Math.floor(Math.random() * colors.length);
        return { posColor: colors[random] };
    };
    /** Functions **/
    Product.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'name') {
                        if (JSON.stringify(json[prop]) !== '[]') {
                            instance._name = json[prop];
                        }
                    }
                    else if (prop === 'description') {
                        if (JSON.stringify(json[prop]) !== '[]') {
                            instance._description = json[prop];
                        }
                    }
                    else if (prop === 'fields') {
                        for (var subProp in json[prop]) {
                            var newField = new Field();
                            newField.key = subProp;
                            newField.translations = json[prop][subProp]["FR"];
                            instance.fields.push(newField);
                        }
                    }
                    else if (prop === 'price') {
                        instance._price = json[prop];
                    }
                    else if (prop === 'stock') {
                        instance.stock = new Stock(json[prop]);
                    }
                    else if (prop === 'quantitySelector') {
                        instance['quantitySelector'] = new ProductQuantitySelector(json[prop]);
                    }
                    else if (prop === 'vat') {
                        instance._vat = json[prop];
                    }
                    else if (prop === 'priceWithTax') {
                        instance._priceWithTax = json[prop];
                    }
                    else if (prop === 'groups') {
                        for (var _i = 0, _a = json[prop]; _i < _a.length; _i++) {
                            var subProp = _a[_i];
                            instance._groups.push(new Group(subProp));
                        }
                    }
                    else if (prop === 'contextVariables') {
                        if (json[prop]) {
                            for (var subProp in json[prop]) {
                                instance.contextVariables.push(new ProductContextVariable(json[prop][subProp]));
                            }
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    Product.prototype.exportToJson = function (withGroups) {
        if (withGroups === void 0) { withGroups = true; }
        if (this.isValid()) {
            var JSONProduct = {};
            JSONProduct['uid'] = this.uid;
            JSONProduct['price'] = this._price;
            JSONProduct['priceWithTax'] = this._priceWithTax;
            JSONProduct['vat'] = this._vat;
            JSONProduct['stockUid'] = this.stockUid;
            JSONProduct['onSale'] = this.onSale;
            JSONProduct['visible'] = this.visible;
            JSONProduct['internalType'] = this.internalType;
            JSONProduct['name'] = this._name;
            JSONProduct['quantitySelector'] = this.quantitySelector.exportToJson();
            JSONProduct['description'] = this._description;
            if (this.fields.length > 0) {
                JSONProduct['fields'] = {};
                for (var _i = 0, _a = this.fields; _i < _a.length; _i++) {
                    var field = _a[_i];
                    Object.assign(JSONProduct['fields'], field.exportToJson());
                }
            }
            JSONProduct['iconUploadUid'] = this.iconUploadUid;
            JSONProduct['needDelivery'] = this.needDelivery;
            JSONProduct['ventilate'] = this.ventilate;
            JSONProduct['position'] = this.position;
            if (this.stock) {
                JSONProduct['stock'] = this.stock.exportToJson();
            }
            if (withGroups && this._groups.length > 0) {
                JSONProduct['groups'] = [];
                for (var _b = 0, _c = this._groups; _b < _c.length; _b++) {
                    var group = _c[_b];
                    JSONProduct['groups'].push(group.exportToJson());
                }
            }
            JSONProduct['contextVariables'] = [];
            for (var _d = 0, _e = this.contextVariables; _d < _e.length; _d++) {
                var context_2 = _e[_d];
                JSONProduct['contextVariables'].push(context_2.exportToJson());
            }
            JSONProduct['customerLabels'] = this.customerLabels;
            return JSONProduct;
        }
        else {
            console.error("exportToJson()");
            if (!this.isQuantityValid()) {
                console.error("Le produit ne peut pas être exporté car les quantités ne sont pas valides.");
            }
            else if (!this.isPriceValid()) {
                console.error("Le produit ne peut pas être exporté car les prix ne sont pas valides.");
            }
            return null;
        }
    };
    /**
     * Checks if the priceWithTax is valid
     * The piceWithTax is valid if: priceWithTax - 0.01 <= price * vat <= priceWithTax + 0.01
     * @returns {boolean} true if valid, false otherwise
     */
    Product.prototype.isPriceValid = function () {
        if (this._vat === 0 &&
            this._price - this._priceWithTax !== 0) {
            return false;
        }
        return !(this._vat !== 0 &&
            Math.abs((this._price * (1 + this._vat / (100 * 100))) - this._priceWithTax) >= 1);
    };
    /**
     * Checks if the product is valid, which means that its data are consistent
     * @returns {boolean} tue if valid, false otherwise
     */
    Product.prototype.isValid = function () {
        var isConform = true;
        if (!this.isPriceValid()) {
            console.error('Error Price Product');
            isConform = false;
        }
        if (!this.isQuantityValid()) {
            console.error('Error Quantity Product');
            isConform = false;
        }
        return isConform;
    };
    Product.prototype.add_group = function (group) {
        if (group === undefined) {
            group = new Group();
        }
        this.isProductUniquable = true;
        this._groups.push(group);
    };
    Product.prototype.isQuantityValid = function () {
        var isValid = true;
        if (this._groups.length > 0 && !this.isProductUniquable) {
            console.error("Product have child and is not uniquable.");
            console.error("Group Length : " + this.groups.length);
            console.error("Min : " + this.quantitySelector.minQuantity);
            console.error("Max : " + this.quantitySelector.maxQuantity);
            console.error("isUniquable : " + this.quantitySelector.isProductUniquable);
            console.error("quantitySelector : " + JSON.stringify(this.quantitySelector.exportToJson()));
            return false;
        }
        if (this.contextVariables.length > 0 && this._groups.length > 0) {
            for (var _i = 0, _a = this.contextVariables; _i < _a.length; _i++) {
                var contextVariable = _a[_i];
                if (!contextVariable.quantitySelector.isProductUniquable) {
                    console.error("ContextVariableUid: " + contextVariable.contextVariableUid + " is not uniquable and product have childs.");
                    return false;
                }
            }
        }
        for (var _b = 0, _c = this._groups; _b < _c.length; _b++) {
            var group = _c[_b];
            if (isValid) {
                isValid = group.isQuantityValid();
            }
            if (!isValid) {
                break;
            }
        }
        return isValid;
    };
    Product.prototype.deleteGroup = function (group) {
        var index = 0;
        var found = false;
        for (var _i = 0, _a = this._groups; _i < _a.length; _i++) {
            var gr = _a[_i];
            if (group.uid === gr.uid) {
                this._groups.splice(index, 1);
                found = true;
                break;
            }
            index++;
        }
        if (!found) {
            alert('Group not find');
        }
    };
    //TODO retourner un tableau car il peut y avoir plusieur fois le même produit dans un groupItem
    Product.prototype.getGroupItemWithProductUid = function (uid) {
        function isInThisGroupItem(uid, groupItem) {
            if (groupItem.productUid === uid) {
                return groupItem;
            }
            else {
                var groupItemTmp_1 = null;
                if (groupItem.groups.length > 0) {
                    for (var _i = 0, _a = groupItem.groups; _i < _a.length; _i++) {
                        var group = _a[_i];
                        groupItemTmp_1 = searchInGroup(uid, group);
                        /**If node is find, loop stops, otherwise, it will send the last occurrence**/
                        if (groupItemTmp_1 !== null) {
                            break;
                        }
                    }
                }
                return groupItemTmp_1;
            }
        }
        function searchInGroup(uid, group) {
            var groupItemTmp = null;
            for (var _i = 0, _a = group.groupItems; _i < _a.length; _i++) {
                var groupItem = _a[_i];
                groupItemTmp = isInThisGroupItem(uid, groupItem);
                if (groupItemTmp !== null) {
                    break;
                }
            }
            return groupItemTmp;
        }
        var groupItemTmp = null;
        for (var _i = 0, _a = this._groups; _i < _a.length; _i++) {
            var group = _a[_i];
            groupItemTmp = searchInGroup(uid, group);
            if (groupItemTmp !== null) {
                break;
            }
        }
        return groupItemTmp;
    };
    Product.prototype.getGroupItem = function (groupItemUid) {
        function isInThisGroupItem(uid, groupItem) {
            if (groupItem.uid === uid) {
                return groupItem;
            }
            else {
                var groupItemTmp = null;
                if (groupItem.groups.length > 0) {
                    for (var _i = 0, _a = groupItem.groups; _i < _a.length; _i++) {
                        var group = _a[_i];
                        groupItemTmp = searchInGroup(uid, group);
                        /**If node is find, loop stops, otherwise, it will send the last occurrence**/
                        if (groupItemTmp !== null) {
                            break;
                        }
                    }
                }
                return groupItemTmp;
            }
        }
        function searchInGroup(uid, group) {
            var groupItemTmp = null;
            for (var _i = 0, _a = group.groupItems; _i < _a.length; _i++) {
                var groupItem = _a[_i];
                groupItemTmp = isInThisGroupItem(uid, groupItem);
                if (groupItemTmp !== null) {
                    break;
                }
            }
            return groupItemTmp;
        }
        for (var _i = 0, _a = this._groups; _i < _a.length; _i++) {
            var group = _a[_i];
            var groupItem = searchInGroup(groupItemUid, group);
            if (groupItem !== null) {
                return { groupItem: groupItem, group: group };
            }
        }
        return null;
    };
    Product.prototype.getProductUids = function () {
        var uuids = [];
        for (var _i = 0, _a = this._groups; _i < _a.length; _i++) {
            var group = _a[_i];
            uuids = uuids.concat(group.getProductUidsInGroupItem());
        }
        return uuids;
    };
    Product.prototype.get_groupItem_Uids = function () {
        function getGroupItemUids(groupItem) {
            var uuids = [];
            if (groupItem.uid) {
                uuids.push(groupItem.uid);
            }
            if (groupItem.groups.length > 0) {
                for (var _i = 0, _a = groupItem.groups; _i < _a.length; _i++) {
                    var group = _a[_i];
                    uuids = uuids.concat(getGroupUuids(group));
                }
            }
            return uuids;
        }
        function getGroupUuids(group) {
            var uuids = [];
            for (var _i = 0, _a = group.groupItems; _i < _a.length; _i++) {
                var groupItem = _a[_i];
                uuids = uuids.concat(getGroupItemUids(groupItem));
            }
            return uuids;
        }
        var uuids = [];
        for (var _i = 0, _a = this._groups; _i < _a.length; _i++) {
            var group = _a[_i];
            uuids = uuids.concat(getGroupUuids(group));
        }
        return uuids;
    };
    Product.prototype.isDenombrable = function () {
        return this._groups.length > 0;
    };
    Product.prototype.get_max_fabricable_unities = function (products, verifyChild) {
        if (verifyChild === void 0) { verifyChild = true; }
        //S'ils n'y a pas d'enfant on renvoie directement le stock du parent.
        if (this._groups.length === 0) {
            return this.get_max_productable_unity_of_this_product_without_considere_child();
        }
        else if (this._groups.length && verifyChild) {
            //Retourner le minimum faisable avec les enfants.
            // On l'initialise au minimum du product actuel (il peut être null si c'est infini.
            var min = this.get_max_productable_unity_of_this_product_without_considere_child();
            for (var _i = 0, _a = this._groups; _i < _a.length; _i++) {
                var group = _a[_i];
                var maxProductable = group.get_max_fabricable_unities(products);
                if (min === null || (maxProductable && maxProductable < min)) {
                    min = maxProductable;
                }
            }
            return min;
        }
        else {
            return null;
        }
    };
    Product.prototype.get_max_productable_unity_of_this_product_without_considere_child = function () {
        if (this.stock && this.stock.currentQty !== null && this.stock.currentQty !== undefined && !isNaN(this.stock.currentQty)) {
            return this.stock.currentQty;
        }
        return null;
    };
    Product.getCorrespondingProduct = function (productUid, products) {
        for (var _i = 0, products_1 = products; _i < products_1.length; _i++) {
            var product = products_1[_i];
            if (product.uid === productUid) {
                return product;
            }
        }
        return null;
    };
    Product.prototype.get_field = function (key) {
        var field = this.search(key);
        if (field && field.translations) {
            return field.translations;
        }
        else {
            return '';
        }
    };
    Product.prototype.set_field = function (key, value) {
        var field = this.search(key);
        if (field) {
            field.translations = value;
        }
        else {
            var newField = new Field();
            newField.key = key;
            newField.translations = value;
            this.fields.push(newField);
        }
    };
    Product.prototype.search = function (key) {
        for (var _i = 0, _a = this.fields; _i < _a.length; _i++) {
            var field = _a[_i];
            if (field.key === key) {
                return field;
            }
        }
        return null;
    };
    return Product;
}(Model));
export default Product;
export var PRODUCT_INTERNAL_TYPE;
(function (PRODUCT_INTERNAL_TYPE) {
    PRODUCT_INTERNAL_TYPE["MENU"] = "MENU";
    PRODUCT_INTERNAL_TYPE["ITEM"] = "ITEM";
    PRODUCT_INTERNAL_TYPE["EXTRA"] = "EXTRA";
    PRODUCT_INTERNAL_TYPE["MENU_FOOD"] = "MENU_FOOD";
    PRODUCT_INTERNAL_TYPE["ITEM_FOOD"] = "ITEM_FOOD";
    PRODUCT_INTERNAL_TYPE["EXTRA_FOOD"] = "EXTRA_FOOD";
    PRODUCT_INTERNAL_TYPE["MENU_EVENT"] = "MENU_EVENT";
    PRODUCT_INTERNAL_TYPE["ITEM_EVENT"] = "ITEM_EVENT";
    PRODUCT_INTERNAL_TYPE["EXTRA_EVENT"] = "EXTRA_EVENT";
    PRODUCT_INTERNAL_TYPE["GLOBAL_HIDDEN"] = "GLOBAL_HIDDEN";
    PRODUCT_INTERNAL_TYPE["PRODUCT_EVENT_NIGHTCLUB_ITEM"] = "PRODUCT_EVENT_NIGHTCLUB_ITEM";
    PRODUCT_INTERNAL_TYPE["PRODUCT_EVENT_NIGHTCLUB_MENU"] = "PRODUCT_EVENT_NIGHTCLUB_MENU";
    PRODUCT_INTERNAL_TYPE["MENU_BAR"] = "MENU_BAR";
    PRODUCT_INTERNAL_TYPE["ITEM_BAR"] = "ITEM_BAR";
    PRODUCT_INTERNAL_TYPE["HIDDEN_BAR"] = "HIDDEN_BAR";
})(PRODUCT_INTERNAL_TYPE || (PRODUCT_INTERNAL_TYPE = {}));
//# sourceMappingURL=Product.js.map